export default "__VITE_ASSET__CUBNWETL__"